import SideNav from './components/SideNav';

export { default as Toggle } from './components/Toggle';
export { default as Nav } from './components/Nav';
export { default as NavItem } from './components/NavItem';
export { default as NavIcon } from './components/NavIcon';
export { default as NavText } from './components/NavText';

module.exports = SideNav;



// WEBPACK FOOTER //
// ./src/index.js